exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Register .Availability {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -ms-flex-align: center;\n  align-items: center; }\n\n.Register .FieldGroup[data-name=\"equalOpportunitiesAgreement\"],\n.Register .FieldGroup[data-name=\"dataProtectionAgreementPart1\"],\n.Register .FieldGroup[data-name=\"dataProtectionAgreementPart2\"] {\n  font-weight: bold;\n  font-size: 16px; }\n\n.RegistrationComplete {\n  margin-top: 200px; }\n\nlabel {\n  white-space: pre-wrap; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/scenes/Register/Register.scss
// module id = 1588
// module chunks = 0